import { render, staticRenderFns } from "./algo-dashboard.html?vue&type=template&id=543960f3&scoped=true&external"
import script from "./algo-dashboard.js?vue&type=script&lang=js&external"
export * from "./algo-dashboard.js?vue&type=script&lang=js&external"
import style0 from "./algo-dashboard.scss?vue&type=style&index=0&id=543960f3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543960f3",
  null
  
)

export default component.exports